// extracted by mini-css-extract-plugin
module.exports = {"list":"_2AOGV","grid":"_3-v49","desktopQuarters":"_3sWpY","tabletHalves":"_18POQ"};